import { useEffect, useMemo, useState } from 'react';
import { KeyOrderType, ListItemId } from '@/components/basic/DragDropTable';

export default function useSyncOrder<T extends ListItemId>(
  originalList: T[] | undefined
) {
  const [keysInOrder, setKeysInOrder] = useState<KeyOrderType[]>([]);

  useEffect(() => {
    originalList && setKeysInOrder(originalList.map((area) => area.id));
  }, [originalList]);

  const memoizedOrderedList = useMemo<T[] | undefined>(() => {
    let orderedList: T[] | undefined = undefined;
    if (originalList) {
      orderedList = [];
      keysInOrder.forEach((key) => {
        const item = originalList.find((item) => item.id === key);
        item && orderedList && orderedList.push(item);
      });
    }
    return orderedList;
  }, [originalList, keysInOrder]);

  return {
    orderedList: memoizedOrderedList,
    keysInOrder,
    setKeysInOrder
  };
}
